import React from 'react';

import {ReactComponent} from '../../assets/svg/layers_icon.svg';

export default () => <ReactComponent />;